import { render } from "./AppConfirm.vue?vue&type=template&id=53fd3213"
import script from "./AppConfirm.vue?vue&type=script&lang=js"
export * from "./AppConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__